import ModelOne from "./models/modelOne";
import ModelTwo from "./models/modelThree";
import ModelThree from "./models/modelThree";
import ModelFour from "./models/modelFour";

const MainTemplate = (route) => {
  return route.model === 1 ? (
    <ModelOne {...route} />
  ) : route.model === 2 ? (
    <ModelTwo {...route} />
  ) : route.model === 3 ? (
    <ModelThree {...route} />
  ) : (
    <ModelFour {...route} />
  );
};

export default MainTemplate;
